import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, filter, Observable } from 'rxjs';

import { TrackingService } from '@modules/shared/services/tracking.service';

@Injectable()
export class AppService {
  private router = inject(Router);
  private title = inject(Title);
  private trackingService = inject(TrackingService);

  public isLightPage$: Observable<boolean>;
  public isLoading$: Observable<boolean>;

  private _isLightPage$ = new BehaviorSubject<boolean>(false);
  private _isLoading$ = new BehaviorSubject<boolean>(false);

  constructor() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this._isLoading$.next(true);
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this._isLoading$.next(false);
      }
    });

    // Track page views
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event) => {
      this.trackingService.push((event as NavigationEnd).urlAfterRedirects);
    });

    this.isLightPage$ = this._isLightPage$.asObservable();
    this.isLoading$ = this._isLoading$.asObservable();
  }

  public setTitle(title: string): void {
    this.title.setTitle(title);
  }

  public getTitle(): string {
    return this.title.getTitle();
  }

  public lightBackgroundPage() {
    this._isLightPage$.next(true);
  }

  public darkBackgroundPage() {
    this._isLightPage$.next(false);
  }
}
